export const backendBaseUrl = "https://eqarcom-gateway-api.agp-dev.com";
// export const backendBaseUrl = "http://localhost:4000";
